import { Grid, Typography } from "@mui/material"
import theme from "./../../../theme"
import SACCPaper from "./../SACCPaper";
import { makeStyles } from "@mui/styles";
import {Colours, SamaggiTypography} from "../../SamaggiTypography";
import {SamaggiButton} from "../../SamaggiButton";

const useStyles = makeStyles(() => ({
    border : {
        width: "100vw",
        minWidth: "800px ! important",
    },
    content : {
        background: "linear-gradient(180deg, #294687 0%, #EEABFF 100%)",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column ! important"
    },
    prompt: {
        textAlign: "center",
        fontWeight: "bold ! important"
    },
    headers : {
        color: "white"
    }
  }));

const objective = {
    prompt : "How can PTTEP utilise digital energy concepts to create a financially, socially, and environmentally responsible corporate policy and accelerate the achievement of Net Zero target goals without compromising economic growth?",
    obj1 : "In a digital era coupled with environmental and social instability, businesses must take the helm to drive forth the movement towards a sustainable future. With global pressure necessitating the reduction of carbon consumption and increased corporate transparency towards social and financial practices, business policies must evolve in tandem with the current trends whilst maintaining their post-COVID demand upsurge. Through leading by example, companies large and small can make a difference, and can inspire action from stakeholders, governments, and citizens.",
    obj2 : "Participants will devise solutions that have the potential to solve an organisational problem to enable the company to achieve a certain business objective. Teams will focus their ideas on how to maintain and stimulate business competitiveness and encourage long-term sustainability in Thailand that can also address the increasing socioeconomic and environmental challenges of tomorrow’s world."
}

const CaseCompObjectives = () => {
    const classes = useStyles();
    return (
        <Grid item>
            <div className={classes.border}>
                <Grid container className={classes.content} spacing={4} sx={{px: {xs: 10, md: 25}, py: 10}}>
                    <Grid item>
                        <SamaggiTypography bold xlarge colour={Colours.white}>Samaggi Academic Conference & Careers Fair 2024</SamaggiTypography>
                    </Grid>
                    <Grid item>
                        <Typography variant="h6" className={classes.headers}>Find out more about this year's event.</Typography>
                    </Grid>
                    <Grid item container direction="row" spacing={3} style={{ display: 'flex', alignItems: 'stretch' }}>
                        <Grid item xs={12} style={{ display: 'flex' }}>
                            <SACCPaper style={{ display: 'flex', flexDirection: 'column' }}>
                                <SamaggiTypography xlarge bold colour={Colours.samaggiGreen} marginBottom={3}>Our Theme</SamaggiTypography>
                                <Grid container direction="column" spacing={4}>
                                    <Grid item container direction="row" spacing={3}>
                                        <Grid item xs={4}>
                                            <div style={{
                                                flex: 1,
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center'
                                            }}>
                                                <SamaggiTypography large bold right italic
                                                                   colour={Colours.darkGray}>
                                                    Learning From the Past, Addressing the Present, and Embracing
                                                    the Future
                                                </SamaggiTypography>
                                            </div>
                                        </Grid>
                                        <Grid item xs={8}>
                                            <SamaggiTypography>Emerging from the pandemic and facing its repercussions, society has been through radical changes at an unprecedented pace, which challenges us to take lessons from the past and adapt to a dynamic world. The pandemic has highlighted fundamental imperfections within the structure of our society, such as the effectiveness of healthcare systems and exacerbated inequalities amongst groups of population. These fundamentals also reflect the effectiveness of society in responding to perpetuating issues such as climate change and political instability. Are there any patterns or symmetries to current trends, and how can we use them to better provide for the current society? New industries and technologies unfold, catalysed by digital disruption, posing the question of how society should make use of these innovations as we move towards a new paradigm.</SamaggiTypography>
                                        </Grid>
                                    </Grid>
                                    <Grid item container direction="row" spacing={3}>
                                        <Grid item xs={4}>
                                            <div style={{
                                                flex: 1,
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center'
                                            }}>
                                                <SamaggiTypography large bold right italic
                                                                   colour={Colours.darkGray}>
                                                    เรียนรู้จากอดีต ปรับใช้ในปัจจุบัน เพื่อก้าวเข้าสู่โลกอนาคต
                                                </SamaggiTypography>
                                            </div>
                                        </Grid>
                                        <Grid item xs={8}>
                                            <SamaggiTypography>สืบเนื่องจากวิกฤตการณ์โรคระบาด Covid-19 สังคมได้ผ่านการเปลี่ยนแปลงครั้งใหญ่อย่างที่ไม่เคยเกิดขึ้นมาก่อน ก่อให้เกิดความตระหนักถึงปัญหาเชิงโครงสร้างของประเทศไทยในด้านต่าง ๆ เช่น ประสิทธิภาพของระบบสาธารณสุข ความเหลื่อมล้ำที่ทวีความรุนแรงมากยิ่งขึ้น มากไปกว่านั้นยังสะท้อนให้เห็นความสามารถของสังคมในการรับมือกับปัญหาอื่น ๆ ที่เรื้อรังมานาน ไม่ว่าจะเป็นการเปลี่ยนแปลงของสภาพภูมิอากาศ หรือปัญหาความขัดแย้งทางการเมืองก็ตาม สิ่งเหล่านี้ชวนให้เกิดการตั้งคำถามว่าเราสามารถเรียนรู้อะไรได้บ้างจากการทบทวนอดีต และในปัจจุบันเราจะสามารถใช้เทคโนโลยีหรือนวัตกรรมใดบ้างเพื่อการสร้างการเปลี่ยนแปลงเชิงบวกให้เกิดขึ้นในสังคมไทย แม้ว่าเราจะกำลังเผชิญกับผลกระทบจากโรคระบาดครั้งใหญ่นี้ซึ่งอาจเพิ่มความท้าทายให้เราทุกคนในการปรับตัวให้ทันกับสถานการณ์โลกอนาคต</SamaggiTypography>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </SACCPaper>
                        </Grid>
                        <Grid item xs={12}>
                            <SACCPaper>
                                <SamaggiTypography xlarge bold colour={Colours.samaggiGreen} marginBottom={3}>Date &
                                    Location</SamaggiTypography>
                                <Grid container direction="row" spacing={5}>
                                    <Grid item xs={12} md={5} style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between'}}>
                                        <Grid container direction="column" spacing={1}>
                                            <Grid item>
                                                <SamaggiTypography large bold>Brunei Gallery – SOAS, University of
                                                    London</SamaggiTypography>
                                            </Grid>
                                            <Grid item>
                                                <SamaggiTypography large>Saturday 20th January 2024</SamaggiTypography>
                                            </Grid>
                                            <Grid item>
                                                <SamaggiTypography large>9:30am - 5:00pm</SamaggiTypography>
                                            </Grid>
                                        </Grid>
                                        <SamaggiButton fullWidth style={{height: "50px", marginTop: "20px"}} onClick={() => {window.location.href = "sacc.samaggisamagom.com/cfas"}}>Register to attend for free through CFAS</SamaggiButton>
                                    </Grid>
                                    <Grid item xs={12} md={7}>
                                        <iframe
                                            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2482.527084018962!2d-0.13113262262588207!3d51.52189167181656!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x48761b31da29254b%3A0xca18ffdd2be73cb1!2sBrunei%20Gallery%20SOAS!5e0!3m2!1sen!2suk!4v1704973171872!5m2!1sen!2suk"
                                            allowFullScreen="" loading="lazy" width={"100%"} style={{"border": 0, minHeight: "300px"}}
                                            referrerPolicy="no-referrer-when-downgrade"></iframe>
                                    </Grid>
                                </Grid>

                            </SACCPaper>
                        </Grid>
                    </Grid>
                </Grid>
            </div>
        </Grid>
    )
}


export default CaseCompObjectives;
